import { render, staticRenderFns } from "./GerenciarGrupos.vue?vue&type=template&id=1197a05a&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarGrupos.vue?vue&type=style&index=0&id=1197a05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1197a05a",
  null
  
)

export default component.exports